module.exports = __webpack_public_path__ + "img/school6.73138924.png";